 <template>
  <div>
    <activity-redirect-item
        :loan-tasks="tasks"
        :current-loan-task="currentTaskName"
        :is-loan-task="true"
        :redirect-activity="redirectActivity"
    ></activity-redirect-item>

    <address-stage-provider
    :propShowSameAsCurrentAddressCheckbox="true"
    :addressType="addressType"
    :tasks="tasks"
    :currentTaskName="currentTaskName"
    ></address-stage-provider>
  </div>
</template>

<script>

import LoanScopeDataHolder from "@/data/model/LoanScopeDataHolder";

import ActivityRedirectItem from "../layout/ActivityRedirectItem";
import {Activities} from "@/utils/ActivityNavigator";
import AddressStageProvider
  from "@/components/providers/AddressStageProvider";
import AddressResponse from '../../data/model/AddressResponse';

export default {
  name: "AddressActivity",
  components: {ActivityRedirectItem, AddressStageProvider},

  computed: {
    redirectActivity() {
      return Activities.LOAN_DETAILS;
    },

    tasks() {
      return [Activities.COMMUNICATION_ADDRESS];
    },

    currentTaskName() {
      return LoanScopeDataHolder.getCurrentLoanTask()
          ? LoanScopeDataHolder.getCurrentLoanTask().name : "";
    },

    addressType() {
      return AddressResponse.COMMUNICATION_ADDRESS_TYPE;
    }
  }
}
</script>

<style scoped></style> 

<!--
<template>
  <div>
    <tool-bar :title="toolbarTitle"></tool-bar>
    <loading :loading="loading"></loading>

    <error-alert-item
      :error-alert-event="errorAlertEvent"
      :network-error="networkError"
      @resetErrorAlertEvent="errorAlertEvent=false">
    </error-alert-item>

    <activity-redirect-item
      :loan-tasks="tasks"
      :current-loan-task="currentTaskName"
      :is-loan-task="true"
      :redirect-activity="redirectActivity"
    ></activity-redirect-item>

    <stage-comment-item></stage-comment-item>

    <refresh-item
      :show="showRefreshItem"
      @onRefresh="fetchInitialData"
    ></refresh-item>

    <div class="margin_top_20" v-show="showUI">
      <div class="item-heading-desc-div margin-left-10 margin-right-10">
        <weex-text class="item-heading">{{addressHeading}}</weex-text>
      </div>

      <wxc-checkbox
        v-show="showSameAsCurrentAddressCheckbox"
        class="margin-left-10 margin-right-10"
        v-for="item in sameAsCurrentAddressCheckboxList"
        :key="item"
        :config="checkBoxConfig"
        :checked="sameAsCurrentAddressDefaultSelection"
        :title="item"
        :value="item"
        @wxcCheckBoxItemChecked="onSameAsCurrentAddressCheckboxClicked"
      ></wxc-checkbox>

      <div class="input_container margin_top_40">
        <weex-text class="input_label">Flat/HouseNo./Floor/Building</weex-text>
        <input
          class="input_with_border_bottom"
          :value="getFieldValue('street')"
          @input="onInputEntered('street', $event.target.value)"
          return-key-type="next">
      </div>

      <div class="input_container">
        <weex-text class="input_label">Colony/Street/Locality</weex-text>
        <input
          class="input_with_border_bottom"
          :value="getFieldValue('addressLine1')"
          @input="onInputEntered('addressLine1', $event.target.value)"
          return-key-type="next">
      </div>

      <div class="input_container">
        <weex-text class="input_label">Landmark</weex-text>
        <weex-text class="input_label_des">(Optional)</weex-text>
        <input
          class="input_with_border_bottom"
          :value="getFieldValue('addressLine2')"
          @input="onInputEntered('addressLine2', $event.target.value)"
          return-key-type="next">
      </div>

      <div class="input_container">
        <weex-text class="input_label">Pin Code</weex-text>
        <input
          class="input_with_border_bottom"
          :value="getFieldValue('postalCode')"
          @input="onPostalEntered($event.target.value)"
          type="number"
          maxlength="6"
          return-key-type="next">
      </div>

      <div class="dropdown_container">
        <wxc-dropdown
          title="State"
          default-item="Select"
          :config="dropdownConfig"
          :disabled="stateDropdownDisabled"
          :select-item="selectState"
          :list="stateList"
          @onItemSelected="onStateSelected"
        ></wxc-dropdown>
      </div>

      <div class="input_container">
        <weex-text class="input_label">District</weex-text>
        <input
          :readonly="disableAddressLine3"
          class="input_with_border_bottom"
          :value="getFieldValue('addressLine3')"
          @input="onInputEntered('addressLine3', $event.target.value)"
          return-key-type="next">
      </div>

      <div class="input_container">
        <weex-text class="input_label">City</weex-text>
        <input
          :readonly="disableCity"
          class="input_with_border_bottom"
          :value="getFieldValue('city')"
          @input="onInputEntered('city', $event.target.value)"
          return-key-type="done">
      </div>

      <wxc-button
        text="Next"
        class="horizontal_center margin_top_40 margin-bottom-20"
        type="blue"
        @wxcButtonClicked="onSubmit"
      ></wxc-button>
    </div>
  </div>
</template>

<script>
import ToolBar from "../layout/ToolBar";
import Loading from "../layout/Loading";
import ActivityRedirectItem from "../layout/ActivityRedirectItem";
import StageCommentItem from "../layout/StageCommentItem";
import ErrorAlertItem from "../layout/ErrorAlertItem";
import WxcButton from "../../../weex-ui/packages/wxc-button";
import WxcDropdown from "../../../weex-ui/packages/wxc-dropdown";
import WxcCheckbox from "../../../weex-ui/packages/wxc-checkbox";
import EzUtils from "../../utils/EzUtils";
import LoanTasksActivityNavigator from "../../utils/LoanTasksActivityNavigator";
import DataTableUtils from "../../utils/DataTableUtils";
import { DefaultResourceConfig } from "../../utils/ImageResourcesUtil";
import { MessageConstants } from "../../utils/MessageConstantUtil";
import { Activities } from "../../utils/ActivityNavigator";
import LoanScopeDataHolder from "../../data/model/LoanScopeDataHolder";
import DataSource from "../../data/DataSource";
import AddressResponse from "../../data/model/AddressResponse";
import AlertService from "../core/alert/AlertService";
import PrefManager from "../../data/model/PrefManager";
import { RolesConstants } from "../../utils/RolesConstants";
import RefreshItem from "../layout/RefreshItem";
import storageUtil from "../../utils/StorageUtil";

const COMMUNICATION_ADDRESS_TYPE = "communication";
const HOME_ADDRESS_TYPE = "home";
const INDIA = "India";

export default {
  name: "CommunicationAddressActivity",
  components: {
    ActivityRedirectItem,
    ErrorAlertItem,
    Loading,
    ToolBar,
    WxcButton,
    WxcDropdown,
    WxcCheckbox,
    StageCommentItem,
    RefreshItem
  },

  data: () => ({
    toolbarTitle: "Communication Address",
    address: {
      street: "",
      addressLine1: "",
      addressLine2: "",
      addressLine3: "",
      city: "",
      postalCode: "",
      stateProvinceId: -1,
      addressTypeId: -1,
      countryId: -1
    },

    currentAddress: {},
    showUI: false,
    stateList: [],
    selectState: null,
    disableCity: false,
    disableAddressLine3: false,
    stateDropdownDisabled: false,
    stateProvinceIdOptions: [],
    loading: false,
    errorAlertEvent: false,
    networkError: {},
    showRefreshItem: false,
    communicationAddressTypeId: -1,
    currentAddressTypeId: -1,
    countryId: -1,
    sameAsCurrentAddressCheckboxList: ["Same as Current Address"],
    showSameAsCurrentAddressCheckbox: false,
    sameAsCurrentAddressDefaultSelection: false
  }),

  methods: {
    showToast(message) {
      AlertService.showToast(message);
    },

    showError(error) {
      this.loading = false;
      this.networkError = error;
      this.errorAlertEvent = true;
    },

    getFieldValue(key) {
      return this.address ? this.address[key] : "";
    },

    onInputEntered(key, value) {
      this.address[key] = value;
    },

    onStateSelected(e) {
      this.onStateEntered(e.value);
    },

    onStateEntered(state) {
      this.selectState = state;
      this.onInputEntered(
        AddressResponse.STATE_PROVINCE_ID,
        parseInt(DataTableUtils.getOptionId(this.stateProvinceIdOptions, state))
      );
    },

    onSameAsCurrentAddressCheckboxClicked(e) {
      this.resetAddressField();
      if (e.checked) {
        this.fillAddressWithCurrentAddress();
      }
    },

    resetAddressField() {
      this.onInputEntered(AddressResponse.STREET, "");
      this.onInputEntered(AddressResponse.ADDRESS_LINE1, "");
      this.onInputEntered(AddressResponse.ADDRESS_LINE2, "");
      this.onInputEntered(AddressResponse.ADDRESS_LINE3, "");
      this.onInputEntered(AddressResponse.CITY, "");
      this.onInputEntered(AddressResponse.STATE_PROVINCE_ID, -1);
      this.onPostalEntered("");
    },

    fillAddressWithCurrentAddress() {
      this.onInputEntered(AddressResponse.STREET, this.currentAddress[AddressResponse.STREET]);
      this.onInputEntered(
        AddressResponse.ADDRESS_LINE1,
        this.currentAddress[AddressResponse.ADDRESS_LINE1]
      );
      this.onInputEntered(
        AddressResponse.ADDRESS_LINE2,
        this.currentAddress[AddressResponse.ADDRESS_LINE2]
      );
      this.onInputEntered(
        AddressResponse.ADDRESS_LINE3,
        this.currentAddress[AddressResponse.ADDRESS_LINE3]
      );
      this.onInputEntered(AddressResponse.CITY, this.currentAddress[AddressResponse.CITY]);
      this.onPostalEntered(this.currentAddress[AddressResponse.POSTAL_CODE]);
    },

    onPostalEntered(postalCode) {
      this.onInputEntered(AddressResponse.POSTAL_CODE, postalCode);
      this.getPostalCodeDetails();
    },

    getPostalCodeDetails() {
      if (EzUtils.validatePostalCode(this.getFieldValue(AddressResponse.POSTAL_CODE))) {
        this.loading = true;
        DataSource.getPincodeDetails(this.getFieldValue(AddressResponse.POSTAL_CODE))
          .then(postalCodeRes => {
            this.loading = false;
            if (postalCodeRes.errorOccurred) {
              this.selectState = "";
              this.stateDropdownDisabled = false;
              this.disableCity = false;
              this.disableAddressLine3 = false;
            } else {
              const postalCodeData = postalCodeRes.data ? postalCodeRes.data : {};
              if (this.isValidState(postalCodeData.state)) {
                this.selectState = postalCodeData.state;
                this.stateDropdownDisabled = true;
              } else {
                this.stateDropdownDisabled = false;
                this.selectState = "";
              }
              if (postalCodeData.district) {
                this.onInputEntered(AddressResponse.ADDRESS_LINE3, postalCodeData.district);
                this.onInputEntered(AddressResponse.CITY, postalCodeData.district);
                this.disableCity = true;
                this.disableAddressLine3 = true;
              } else {
                this.disableCity = false;
                this.disableAddressLine3 = false;
              }
            }
          });
      } else {
        this.selectState = "";
        this.stateDropdownDisabled = false;
        this.disableCity = false;
        this.disableAddressLine3 = false;
      }
    },

    isValidState(state) {
      let validState = false;
      this.stateList && this.stateList.forEach(item => {
        if (item && item === state) {
          validState = true;
        }
      });

      return validState;
    },

    onSubmit() {
      if (this.checkForValidation()) {
        const addressPayload = AddressResponse.getAddressPayload(this.address);
        this.loading = true;
        DataSource.saveClientAddress(
          LoanScopeDataHolder.getClientId(),
          this.address[AddressResponse.ADDRESS_TYPE_ID],
          addressPayload
        )
          .then(clientAddressSaveRes => {
            this.loading = false;
            if (clientAddressSaveRes.errorOccurred) {
              this.showError(clientAddressSaveRes.data);
            } else {
              this.completeCurrentTaskAndGetNextTask();
            }
          })
      }
    },

    checkForValidation() {
      if (!this.getFieldValue(AddressResponse.STREET)
        || !this.getFieldValue(AddressResponse.ADDRESS_LINE1)
        || !this.getFieldValue(AddressResponse.ADDRESS_LINE3)
        || !this.getFieldValue(AddressResponse.CITY)
        || !this.getFieldValue(AddressResponse.POSTAL_CODE)
      ) {
        this.showToast(MessageConstants.EMPTY_FIELD_MESSAGE);
        return false;
      }

      if (!this.isValidStreetAddress()) {
        this.showToast(MessageConstants.INVALID_STREET_ADDRESS_MESSAGE);
        return false;
      }

      if (!EzUtils.validatePostalCode(this.getFieldValue(AddressResponse.POSTAL_CODE))) {
        this.showToast(MessageConstants.INVALID_POSTAL_CODE_MESSAGE);
        return false;
      }

      if (!this.getFieldValue(AddressResponse.STATE_PROVINCE_ID)
        || parseInt(this.getFieldValue(AddressResponse.STATE_PROVINCE_ID)) === -1
      ) {
        this.showToast(MessageConstants.SELECT_STATE_MESSAGE);
        return false;
      }

      return true;
    },

    isValidStreetAddress() {
      let streetArray = this.getFieldValue(AddressResponse.STREET).trim().split(" ");
      if (streetArray.length < 2) {
        return false;
      }
      let streetItemCount = 0;
      streetArray.forEach(streetSplitValue => {
        streetItemCount = (streetSplitValue.trim().length > 1) ? streetItemCount + 1
          : streetItemCount;
      });

      return streetItemCount > 0;
    },

    completeCurrentTaskAndGetNextTask() {
      this.loading = true;
      LoanTasksActivityNavigator.getNextTask(this.tasks)
        .then(res => {
          this.loading = false;
          if (res.errorOccurred) {
            this.showError(res.data);
          }
        });
    },

    filterState() {
      this.stateList = [];
      const states = [];
      this.stateProvinceIdOptions.forEach(code => {
        states.push(code.name);
      });
      states.sort();
      this.stateList = states;
    },

    fetchInitialData() {
      this.showRefreshItem = false;
      this.loading = true;
      DataSource.getAddressTemplates()
        .then(addressTemplateRes => {
          this.loading = false;
          if (addressTemplateRes.errorOccurred) {
            this.showError(addressTemplateRes.data);
            this.showRefreshItem = true;
          } else {
            this.communicationAddressTypeId = DataTableUtils.getOptionId(
              addressTemplateRes.data[AddressResponse.ADDRESS_TYPE_ID_OPTIONS],
              COMMUNICATION_ADDRESS_TYPE
            );
            this.currentAddressTypeId = DataTableUtils.getOptionId(
              addressTemplateRes.data[AddressResponse.ADDRESS_TYPE_ID_OPTIONS],
              HOME_ADDRESS_TYPE
            );
            this.countryId = DataTableUtils.getOptionId(
              addressTemplateRes.data[AddressResponse.COUNTRY_ID_OPTIONS],
              INDIA
            );
            this.stateProvinceIdOptions = addressTemplateRes.data[AddressResponse.STATE_PROVINCE_ID_OPTIONS];
            this.filterState();
            this.fetchClientAddress();
          }
        })
    },

    fetchClientAddress() {
      this.loading = true;
      DataSource.getClientAddress(
        LoanScopeDataHolder.getClientId(),
        new Array(true),
        this.currentAddressTypeId
      )
        .then(clientAddressRes => {
          this.loading = false;
          if (clientAddressRes.errorOccurred) {
            this.showError(clientAddressRes.data);
            this.showRefreshItem = true;
          } else {
            this.showUI = true;
            this.onInputEntered(AddressResponse.STATE_PROVINCE_ID, -1);
            this.onInputEntered(AddressResponse.ADDRESS_TYPE_ID, this.communicationAddressTypeId);
            this.onInputEntered(AddressResponse.COUNTRY_ID, this.countryId);

            const addresses = clientAddressRes.data;
            if (EzUtils.isNotEmpty(addresses)) {
              this.currentAddress = addresses[addresses.length - 1];
              this.showSameAsCurrentAddressCheckbox = true;
              this.sameAsCurrentAddressDefaultSelection = true;
            }
          }
        })
    }
  },

  mounted: function () {
    this.fetchInitialData();
  },

  computed: {
    redirectActivity() {
      return Activities.LOAN_DETAILS;
    },

    tasks() {
      return [Activities.COMMUNICATION_ADDRESS];
    },

    currentTaskName() {
      return LoanScopeDataHolder.getCurrentLoanTask()
        ? LoanScopeDataHolder.getCurrentLoanTask().name
        : "";
    },

    dropdownConfig() {
      return DefaultResourceConfig.DROP_DOWN;
    },

    addressHeading() {
      const addressOwner = this.isAgent ? "customer's" : "your";
      return `Please enter ${addressOwner} Communication address`;
    },

    isAgent() {
      return PrefManager.doesUserHasRole(RolesConstants.AGENT);
    },

    checkBoxConfig() {
      return DefaultResourceConfig.CHECK_BOX;
    },
  }
}
</script>

<style scoped src="../../assets/style/base.css"></style>
-->